{
  "email": "E-Mail",
  "showPassword": "Passwort anzeigen",
  "hidePassword": "Passwort verbergen",
  "welcomeText": "Erfasse, analysiere und transformiere dein Unternehmen in Tagen - nicht Monaten.",
  "certDicisTitle": "Besuche unser Compliance-Profil",
  "certDicisAlt": "ISO 9001 + 27001 zertifiziertes Unternehmen (DICIS)",
  "certDsgvoAlt": "DSGVO konform – Hosted in Europe",
  "certGobdAlt": "GoBD Ready",
  "dontHaveAccount": "Kein Konto vorhanden",
  "contactCompany": "Kontaktiere BLIKS IO",
  "loading": "Lädt...",
  "byContinueTermFull": "Durch Fortfahren stimmst du den <terms>Nutzungsbedingungen</terms> und <privacy>Datenschutzrichtlinien</privacy> zu.",
  "termOfService": "Nutzungsbedingungen",
  "privacyPolicy": "Datenschutzrichtlinien",
  "termsLanguageFallbackNotice": "Die offizielle Fassung dieser Lizenzbedingungen liegt in deutscher und englischer Sprache vor. Nachfolgend wird die englische Fassung angezeigt.",
  "backToLogin": "Zurück zur Anmeldung",
  "emailIsRequired": "E-Mail ist erforderlich",
  "loggingOut": "Du wirst abgemeldet...",
  "switchingWorkspace": "Workspace wird gewechselt...",
  "ssoSigningIn": "Du wirst angemeldet...",
  "ssoSignInFailed": "Anmeldung fehlgeschlagen",
  "selectWorkspaceDescription": "Wähle den Workspace, in dem du weitermachen möchtest",
  "selectWorkspaceCurrent": "Aktueller Workspace",
  "selectWorkspacePending": "Eingeladen",
  "noWorkspaceForEmail": "Für diese E-Mail-Adresse wurde kein Workspace gefunden. Prüfe die Adresse oder wende dich an deine Administration."
}
